import { Maintenance } from '@bzbs/react-api-client';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { useBuzzebeesServiceContext } from './buzzebees_service_provider';

export type MaintenanceContextType = {
  isMaintenance: boolean | null;
  maintenanceData: Maintenance | null;
};

export const MaintenanceContext = createContext<MaintenanceContextType>({
  isMaintenance: null,
  maintenanceData: null,
});

export const useMaintenanceContext = () => {
  return useContext(MaintenanceContext);
};

export const MaintenanceProvider = ({ children }: { children: React.ReactNode }) => {
  const { bzbsService, appId } = useBuzzebeesServiceContext();
  const [isMaintenance, setIsMaintenance] = useState<boolean | null>(null);
  const [maintenanceData, setMaintenanceData] = useState<Maintenance | null>(null);

  useEffect(() => {
    const checkMaintenance = async () => {
      const result = await bzbsService.blob.maintenance(appId);
      if (result.type === 'success') {
        if (result.model.enabled === true) {
          setIsMaintenance(true);
          setMaintenanceData(result.model);
        }
      } else {
        setIsMaintenance(false);
        setMaintenanceData(null);
      }
    };

    checkMaintenance();
  }, []);

  return (
    <MaintenanceContext.Provider
      value={{
        isMaintenance,
        maintenanceData,
      }}
    >
      {children}
    </MaintenanceContext.Provider>
  );
};
